import request from "@/helper/request";
// 提交订单
export function placeOrder(data) {
  return request({
    url: "/json/order/placeOrder",
    method: "post",
    data: data
  });
}




// confirmOrder 确认订单

export function confirmOrder(data) {
  return request({
    url: "/json/order/confirmOrder",
    method: "post",
    data: data
  });
}

//删除订单  /json/order/delete
export function deleteOrder(data) {
  return request({
    url: "/json/order/del",
    method: "post",
    data: data
  });
}

//查询指定订单的信息

export function getOrderDetail(data) {
  return request({
    url: "/json/order/read",
    method: "post",
    data: data
  });
}

//查询用户信息

export function getUserInfo(data) {
  return request({
    url: "/json/member/read",
    method: "post",
    data: data
  });
}






//订单查询 /json/order/list

export function listOrder(data) {
  return request({
    url: "/json/order/list",
    method: "post",
    data: data
  });
}

// 支付同步回调及获取支付结果
// 仅会员调用，获取订单信息，支付完成后同步调用

export function listDetailOrder(data) {
  return request({
    url: "/json/order/syncCallback",
    method: "post",
    data: data
  });
}

//合同下载
// /json/contract/read

export function getHetong(data) {
  return request({
    url: "json/contract/read",
    method: "post",
    data: data
  });
}

// 确认收货

export function suregetGood(data) {
  return request({
    url: "/json/order/receipt",
    method: "post",
    data: data
  });
}


export function cancelgood(data) {
  return request({
    url: "/json/order/cancel",
    method: "post",
    data: data
  });
}















